"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const asyncIterate_1 = __importDefault(require("../asyncIterate"));
class EventBusImpl {
    constructor(logger) {
        this.listeners = [];
        this.dispatch = async (event) => {
            this.logger.log(`Dispatching event "${event.name}"`);
            await (0, asyncIterate_1.default)(this.listeners, async (listener) => listener.onEvent(event));
            this.logger.log(`Event "${event.name}" dispatched`);
        };
        this.logger = logger;
    }
    registerListener(eventListener) {
        this.listeners.push(eventListener);
    }
}
exports.default = EventBusImpl;
//# sourceMappingURL=EventBusImpl.js.map